exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".busy-indicator---2WrNX {\n  top: 0;\n  left: 0;\n  position: fixed;\n  z-index: 2000;\n  width: 100%;\n  height: 100%;\n  background: rgba(225, 225, 225, .5); }\n", ""]);

// exports
exports.locals = {
	"busy-indicator": "busy-indicator---2WrNX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/busy-indicator/busy-indicator.scss
// module id = GLqN
// module chunks = 1